/**
 * A test case's "What this tests": a short, muted block with what the case is testing and why,
 * shown under the case title and above its steps. Renders nothing when there is no text (older
 * cases have none until someone writes one). (docs/test-suite.md, "What this tests")
 */
export function CaseDescription({ description }: { description?: string | null }) {
  const text = description?.trim();
  if (!text) return null;
  return (
    <section className="cdesc" aria-label="What this tests">
      <p className="cdesc-h">What this tests</p>
      <p className="cdesc-text">{text}</p>
    </section>
  );
}
